<script>
import RawData from "@/components/widgets/raw-data.vue";
export default {
    props: {
        years: {
            type: Array,
            required: true,
        },
    },
    components: {
        RawData,
    },
    data() {
        return {
            filter: "",
        };
    },
    methods: {
        filterTemplates(templates) {
            if (!this.filter) return templates;
            return templates.filter(template => template.description.toLowerCase().includes(this.filter.toLowerCase()));
        },
    },
};
</script>
<template>
    <div>
        <div class="d-flex justify-content-between align-items-center mb-4">
            <div class="d-flex gap-1">
                <b-form-input autocomplete="off" v-model="filter" type="search" placeholder="Search Budget Call..."
                    class="form-control w-auto"></b-form-input>
            </div>
        </div>
        <div>
            <div v-for="x in years" :key="x.year" class="mb-4">
                <h5>Year {{ x.year }}</h5>
                <template v-if="x.templates.length == 0">
                    <div class="broken-border py-5 d-flex align-items-center justify-content-center br-5 cursor-pointer hover-underline"
                        @click="$emit('create-template', x.year)">
                        <h5 class="text-muted mb-0 ">
                            <i class="bx bx-plus"></i>Create New Budget Call ({{ x.year }})
                        </h5>
                    </div>
                </template>
                <template v-else>
                    <b-card no-body v-for="y in filterTemplates(x.templates)" :key="y.id" class="mb-2 hover-toggle">
                        <RawData :data="y" v-if="$store.state.decrypt.isAdmin()" />
                        <b-card-header class="py-4">
                            <div class="d-flex justify-content-between">
                                <div>
                                    <h4 class="mb-2">{{ y.description }}</h4>
                                    <span v-for="z in y.campuses" :key="`template-info-${y.id}-${z.id}`">
                                        <span class="bg-success py-0 px-2 me-1 br-5 text-white cursor-pointer"
                                            :id="`template-info-${y.id}-${z.id}`">{{ z.campusName }}</span>
                                        <b-popover :key="`popover-${y.id}-${z.id}`"
                                            :target="`template-info-${y.id}-${z.id}`" triggers="click blur"
                                            custom-class="popover-custom" :show.sync="z.showPV">
                                            <div>
                                                <span>Reports</span>
                                                <div class="border-top border-bottom py-1 mt-2"
                                                    @click="$emit('print-form5', { templateId: y.id, campusId: z.id })">
                                                    <a href="javascript:void(0);" class="text-white hover-underline">DBM
                                                        Form 5 - Tier 1</a>
                                                </div>
                                                <div class="border-bottom py-1"
                                                    @click="$emit('print-form7', { templateId: y.id, campusId: z.id })">
                                                    <a href="javascript:void(0);" class="text-white hover-underline">DBM
                                                        Form 7 - Tier 2</a>
                                                </div>
                                                <div class="border-bottom py-1 "
                                                    @click="$emit('print-form8', { templateId: y.id, campusId: z.id })">
                                                    <a href="javascript:void(0);" class="text-white hover-underline">DBM
                                                        Form 8 - Budget Summary</a>
                                                </div>
                                            </div>
                                        </b-popover>
                                    </span>
                                    <div class="mt-2">
                                        <a href="javascript:void(0);" class="mb-0 d-flex align-items-center"
                                            @click="$emit('view-proposal', y)">View Proposals <i
                                                class="bx bx-chevron-right"></i></a>
                                    </div>
                                </div>
                                <div class="hover-content align-items-start gap-1">
                                    <a href="javascript:void(0);" title="View Logs" @click="$emit('view-logs', y)">
                                        <i class="bx bx-receipt text-secondary font-size-22"></i>
                                    </a>
                                    <b-dropdown id="dropdown-dropleft" right variant="btn-link text-purple p-0"
                                        toggle-class="text-decoration-none" menu-class="dropdown-menu-end" no-caret>
                                        <template #button-content>
                                            <i class="bx bx-printer font-size-22"></i>
                                        </template>
                                        <b-dropdown-item @click="$emit('print-form2', { templateId: y.id })">Form 2 -
                                            RDC</b-dropdown-item>
                                        <b-dropdown-item @click="$emit('print-form8', { templateId: y.id })">Form 8 -
                                            Budget Summary</b-dropdown-item>
                                    </b-dropdown>
                                    <a href="javascript:void(0);" title="Edit Budget Call"
                                        @click="$emit('edit-template', y)">
                                        <i class="bx bx-edit text-success font-size-22"></i>
                                    </a>
                                    <a href="javascript:void(0);" title="Delete Budget Call"
                                        @click="$emit('delete-template', y)">
                                        <i class="bx bx-trash text-danger font-size-22"></i>
                                    </a>
                                </div>
                            </div>
                        </b-card-header>
                    </b-card>
                    <div class="text-center">
                        <a href="javascript:void(0);" @click="$emit('create-template', x.year)">
                            <i class="bx bx-plus"></i>
                            Add More Budget Call for {{ x.year }}
                        </a>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>